
const _c = (typeof window !== 'undefined' && window.EDCSERVER_CONFIG) || {};
module.exports = {
   apiDomain: _c.apiDomain || "localhost",
   googleApiKey: _c.googleApiKey || "AIzaSyDuDbZ8yEK7ocQtdmoB5JKQOgeF40-fIC0",
   cloudFlareSelfRegTurnstileSiteKey: _c.cloudFlareSelfRegTurnstileSiteKey || "0x4AAAAAAA5m5QHgpPoCVJIG",
};
      